module.exports = __webpack_public_path__ + "static/media/Decisions_Step2_Image19b.6d3c3154.webp";